function ProfilePageSubmenu({ renderItems, translate }) {
  const items = [
    { label: translate('profile'), link: 'info' },
    { label: translate('devices'), link: 'devices' },
    { label: translate('security'), link: 'security' },
    { label: translate('logs'), link: 'logs' },
  ];

  return renderItems(items);
}

export default ProfilePageSubmenu;
